import { Link } from "react-router-dom";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="text-gray-500 flex flex-col justify-center items-center gap-1">
      <div className="text-sm flex-grow-0 flex-shrink-0 flex flex-row justify-center items-center flex-wrap gap-1">
        <div>By using the app, you agree to our</div>
        <div className="flex flex-row justify-center items-center gap-1">
          <Link
            className="text-blue-600"
            to="https://referral-stream.webflow.io/terms-of-service"
          >
            Terms of Service
          </Link>
          &
          <Link
            className="text-blue-600"
            to="https://referral-stream.webflow.io/privacy-policy"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
      <div className="mb-4 text-sm flex-grow-0 flex-shrink-0">
        Copyright © {currentYear} Referral Stream. All rights reserved.
      </div>
    </div>
  );
};
